/**
 * Created by shinan.chen on 2021/12/25.
 */
import {getCommon, postCommon } from '../tools';
import * as config from '../config';

export interface ICourseDefinition{
    id:number,
    name:string,
    remark:string,
    unitPrice:number,
    enable:boolean,
}

export const listCourseDefinitions = () =>
    getCommon({
        url: `${config.SERVICE_URL}/course_definition/list_all`,
    });

export const createCourseDefinition = (data:ICourseDefinition) =>
    postCommon({
        url: `${config.SERVICE_URL}/course_definition/create`,
        data
    });

export const updateCourseDefinition = (data:ICourseDefinition) =>
    postCommon({
        url: `${config.SERVICE_URL}/course_definition/update`,
        data
    });

export const deleteCourseDefinition = (id:number) =>
    postCommon({
        url: `${config.SERVICE_URL}/course_definition/delete?id=${id}`
    });

export const pageCourseDefinitions = (pageNum:number,pageSize:number) =>
    getCommon({
        url: `${config.SERVICE_URL}/course_definition/page?pageNum=${pageNum}&&pageSize=${pageSize}`,
    });